import { differenceWith, flip, isEmpty, map, pathOr, pipe, pluck } from 'ramda';
import { convertMapToKeyValueObjectArray } from '../../../../../../reducers/helpers/instance.property.helper';
var compareIdToProductId = function compareIdToProductId(existing, cart) {
  return parseInt(existing.Product.Id, 10) === parseInt(cart.ProductId, 10);
};
var compareProductIdToId = function compareProductIdToId(cart, existing) {
  return parseInt(cart.ProductId, 10) === parseInt(pathOr(0, ['Product', 'Id'], existing), 10);
};
var flippedParseInt = flip(parseInt);
var parseBase10 = flippedParseInt(10);
export var getRemoveItems = function getRemoveItems(currentSelections, existingChildren) {
  return pipe(differenceWith(compareIdToProductId, existingChildren), pluck('Id'), map(parseBase10))(currentSelections || []);
};
export var getAddItems = function getAddItems(currentSelections, existingChildren) {
  return pipe(differenceWith(compareProductIdToId, currentSelections), map(function (currentItemSelection) {
    return {
      BundleId: currentItemSelection.BundleId,
      InstanceProperties: convertMapToKeyValueObjectArray(currentItemSelection.InstanceProperties),
      ProductId: parseInt(currentItemSelection.ProductId, 10),
      PricingPlanId: currentItemSelection.PricingPlanId
    };
  }))(existingChildren);
};
var isNewPricingPlan = function isNewPricingPlan(currentPricingPlanId, existingSubscriptionItem) {
  if (existingSubscriptionItem !== null && existingSubscriptionItem !== void 0 && existingSubscriptionItem.ChangePricingPlan) {
    return currentPricingPlanId && currentPricingPlanId !== pathOr(null, ['ChangePricingPlan', 'Id'], existingSubscriptionItem);
  }
  return currentPricingPlanId && currentPricingPlanId !== pathOr(null, ['PricingPlan', 'Id'], existingSubscriptionItem);
};
export var getChangeItems = function getChangeItems(currentPricingPlanId, existingSubscriptionItem) {
  if (!isNewPricingPlan(currentPricingPlanId, existingSubscriptionItem)) {
    return [];
  }
  return [{
    PricingPlanId: currentPricingPlanId,
    SubscriptionItemId: existingSubscriptionItem.Id
  }];
};
export var getReplaceItems = function getReplaceItems(updatedSubscriptionItem, currentSubscriptionItemToReplaceId) {
  if (!updatedSubscriptionItem || isEmpty(updatedSubscriptionItem) || !currentSubscriptionItemToReplaceId) {
    return [];
  }
  return [Object.assign({}, updatedSubscriptionItem, {
    SubscriptionItemId: currentSubscriptionItemToReplaceId
  })];
};
export var getEditItems = function getEditItems(updatedSubscriptionItem, existingChildren, editSubscriptionItem) {
  var addItems;
  var changeItems = getChangeItems(updatedSubscriptionItem.PricingPlanId, editSubscriptionItem);
  var removeItems = getRemoveItems(updatedSubscriptionItem.ChildItems, existingChildren);
  if (changeItems.length) {
    addItems = getAddItems(updatedSubscriptionItem.ChildItems, []);
  } else {
    addItems = getAddItems(updatedSubscriptionItem.ChildItems, existingChildren);
  }
  return {
    addItems: addItems,
    changeItems: changeItems,
    removeItems: removeItems
  };
};
export var noItemsModified = function noItemsModified(editItems) {
  return editItems.changeItems.length === 0 && editItems.removeItems.length === 0 && editItems.addItems.length === 0;
};